import { saveAs } from 'file-saver'

export const downloadFile = (data: ArrayBuffer, type = 'application/zip') => {
  const blob = window.URL.createObjectURL(new Blob([data], { type }))
  saveAs(blob, 'documents.zip')
}
